import React from "react";
import dashboard from './dashboard';

export default {
    ...dashboard,
    appId: "site/dashboard",
    appType: "dashboard"
};